import { render, staticRenderFns } from "./tworeport.vue?vue&type=template&id=20de4506&scoped=true"
import script from "./tworeport.vue?vue&type=script&lang=js"
export * from "./tworeport.vue?vue&type=script&lang=js"
import style0 from "./tworeport.vue?vue&type=style&index=0&id=20de4506&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de4506",
  null
  
)

export default component.exports